































import { HeaderData } from '@/config/interfaces'
import ApplicationsMenu from '@/components/ApplicationsMenu.vue'
import AccountMenu from '@/components/AccountMenu.vue'
import { NavigationMixin } from '@/mixins/navigationMixin'

export default NavigationMixin.extend({
  name: 'Header',
  components: { ApplicationsMenu, AccountMenu },
  computed: {
    headerData (): Array<HeaderData> {
      return this.$store.getters.getHeaderData
    }
  }
})
